"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feedback = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _defaultTranslations = require("../constants/defaultTranslations");
var _models = require("../models");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Feedback = props => {
  const {
    displayFeedback,
    closeFeedback
  } = props;
  let isOpen = false;
  let message;
  if (displayFeedback === _models.DisplayFeedback.Delete) {
    isOpen = true;
    message = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _models.TranslationKey.deletedFeedback,
      defaultMessage: _defaultTranslations.defaultTranslations.deletedFeedback
    });
  }
  if (displayFeedback === _models.DisplayFeedback.Verify) {
    isOpen = true;
    message = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _models.TranslationKey.verifiedFeedback,
      defaultMessage: _defaultTranslations.defaultTranslations.verifiedFeedback
    });
  }
  if (displayFeedback === _models.DisplayFeedback.Add) {
    isOpen = true;
    message = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _models.TranslationKey.addAddressFeedback,
      defaultMessage: _defaultTranslations.defaultTranslations.addAddressFeedback
    });
  }
  if (displayFeedback === _models.DisplayFeedback.Update) {
    isOpen = true;
    message = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _models.TranslationKey.editAddressFeedback,
      defaultMessage: _defaultTranslations.defaultTranslations.editAddressFeedback
    });
  }
  if (isOpen) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
      open: isOpen,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {}),
      timeoutMs: 2000,
      sx: {
        '& .MuiOriFeedbackNotification-notification': {
          height: 'auto',
          minHeight: '130px',
          wordBreak: 'break-word',
          // override import styles from ori-ui
          padding: '5px !important'
        },
        textAlign: 'center'
      },
      onClose: closeFeedback,
      children: message
    });
  }
  return null;
};
exports.Feedback = Feedback;
